import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { formatUZS } from '@/lib/format';
import { ChartTooltipBox } from './chart-bits';

export type PaymentSlice = { key: string; label: string; sum: number; count: number; pct: number; color: string };

export function PaymentPieChart({ data }: { data: PaymentSlice[] }) {
  const { t } = useTranslation();
  const rows = data.filter((d) => d.sum > 0);

  if (rows.length === 0) {
    return <div className="p-6 text-center text-sm text-muted-foreground">{t('tick_reports.noData')}</div>;
  }

  return (
    <div className="h-[240px]">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={rows} dataKey="sum" nameKey="label" innerRadius={50} outerRadius={90} paddingAngle={2}>
            {rows.map((r) => (
              <Cell key={r.key} fill={r.color} />
            ))}
          </Pie>
          <Tooltip
            content={({ active, payload }) =>
              active && payload?.length ? (
                <ChartTooltipBox
                  title={String(payload[0]?.payload?.label ?? '')}
                  rows={[
                    { label: t('tick_reports.colSum'), value: formatUZS(Number(payload[0]?.payload?.sum ?? 0)) },
                    { label: t('tick_reports.colTransactions'), value: t('tick_reports.count', { n: payload[0]?.payload?.count ?? 0 }) },
                    { label: t('tick_reports.colShare'), value: `${Number(payload[0]?.payload?.pct ?? 0).toFixed(1)}%` },
                  ]}
                />
              ) : null
            }
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
